import { render } from "./NextButton.vue?vue&type=template&id=dc5da716"
import script from "./NextButton.vue?vue&type=script&lang=js"
export * from "./NextButton.vue?vue&type=script&lang=js"

import "./NextButton.vue?vue&type=style&index=0&id=dc5da716&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__